module.exports = __webpack_public_path__ + "static/media/coolsky.cefdc264.jpg";